<style lang="stylus"></style>

<template>
    <div style="pointer-events: none" :class="{ 'active-work': imgLoad }">
        <div class="mo-work--wrapper" @click="preview()" style="pointer-events: auto">
            <div class="mo-work--mask" v-if="type == 'center' || type == 'searchPage'">
                <div class="mo-work--box" v-if="!internal && work.is_pay_package">
                    <div
                        class="mo-work--sourcevip"
                        :content="$t('useTip')"
                        v-tippy="{ placement: 'top', arrow: true, theme: 'light' }"
                        @click.stop="toUse"
                    >
                        <img class="source-vip-icon" :src="require('@/home/assets/img/source-vip.png')" />
                        <div class="text">{{ $t("use") }}</div>
                    </div>
                </div>
                <div class="mo-work--usebtn" @click.stop="toUse" v-else>
                    <div class="text">{{ $t("use") }}</div>
                </div>
            </div>
            <div class="mo-work--collect" v-show="type != 'review'" @click.stop="collect" :class="{ active: hasCollected }">
                <img src="@/home/assets/img/like-active.png" v-if="hasCollected" alt="" />
                <img src="@/home/assets/img/likes.png" v-else alt="" />
            </div>
            <div class="mo-work--pager" v-if="work.page_num && work.page_num > 1">
                <iconSymbol name="pager" width="24" />
                &nbsp;{{ work.page_num }}
            </div>
            <div class="mo-work--hot" v-if="index < 10 && isHot">
                <img :src="require(`@/home/assets/img/work/top${index + 1}.svg`)" alt="top" />
            </div>
            <div class="mo-work--img-wrap" :style="wrapStyle">
                <img :src="thumbSrc" :title="work.discription" class="mo-work--img" @load="imgLoad = true" @error="loadErr" />
            </div>
            <span class="mo-work--description" v-if="false">{{ work.description }}</span>
            <!-- 兼职人员已处理标志  -->
            <div
                v-if="work.worker_check"
                class="mo-work--report-num mo-work--worker-check"
                :style="{ background: work.worker_check == 3 ? '#ff3434' : '#00be84' }"
            />
            <!-- 审核按钮，review和report里才有 -->
            <div v-if="type == 'allReview' || type == 'review' || type == 'report'" class="mo-work--operation">
                <Tooltip placement="bottom" content="操作" @click.native.stop="showReviewModify()">
                    <iconSymbol class="mo-work--operation-icon" name="edit-small" />
                </Tooltip>
            </div>
            <div v-show="!work.cover_height" v-if="type == 'allReview' || type == 'review' || type == 'report'" class="mo-work--thumb-error">
                <Tooltip placement="bottom" content="缺少图片数据" @click.native.stop="showReviewModify()">
                    <img src="@/home/assets/img/img-error.png" alt="" />
                </Tooltip>
            </div>
            <!-- 举报数量，report里才有 -->
            <div v-if="type == 'report'" class="mo-work--report-num">
                {{ work.report }}
            </div>
            <!-- 从专辑中删除作品，album里才有 -->
            <div v-if="type == 'album'" class="mo-work--operation">
                <iconSymbol class="mo-work--operation-icon" name="close-icon" @click.native.stop="deleteWorkFromAlbum(work.id)" />
            </div>
            <!-- 添加作品到专辑，album里才有 -->
            <div v-if="type == 'albumSearch'" class="mo-work--operation">
                <iconSymbol class="mo-work--operation-icon" name="add" @click.native.stop="addWorkToAlbum(work.id)" />
            </div>
            <template v-if="debug && work.debug && type == 'userWorks'">
                计算过程
                <div v-for="item in work.debug.split('\n')" :key="item.id">
                    {{ item }}
                </div>
            </template>
            <template v-if="type == 'center' || type == 'userWorks' || type == 'searchPage'">
                <!-- 购买状态，只有模板中心里面有 -->
                <span v-if="hasBought" class="mo-work--hint">{{ $t("bought") }}</span>
            </template>
            <!-- <template v-if="type=='collection'">
                <span
                    v-if="hasBought"
                    class="mo-work--hint"
                >{{ $t('bought') }}</span>
                <span
                    v-else
                    class="mo-work--hint"
                >{{ priceHint }}</span>
            </template> -->
        </div>
        <div class="mo-work--recommend" v-if="work.chosen == 1">
            <img src="@/home/assets/img/work/recommend.svg" alt="recommend" />
        </div>
        <template v-if="type == 'allReview' || type == 'review' || type == 'report'">
            <span class="mo-work--text">{{ work.title }}</span>
            <span class="mo-work--text mo-work--text__red">价格：{{ work.price }}元</span>
            <span class="mo-work--text">时间：{{ work.created_at }}</span>
            <span class="mo-work--text">作品ID：{{ work.id }}</span>
            <span class="mo-work--text">作者：{{ work.author }}</span>
            <span class="mo-work--text">作者ID：{{ work.user_id || work.url.split("/")[1] }}</span>
        </template>
        <template
            v-if="type == 'center' || type == 'collection' || type == 'userWorks' || type == 'album' || type == 'albumSearch' || type == 'searchPage'"
        >
            <span class="mo-work--text" style="pointer-events: auto" @click="preview()">{{ work.title }}</span>
            <div class="mo-work-cotent">
                <div class="mo-work--number-area" style="pointer-events: auto">
                    <div class="mo-work--numbers">
                        <div class="mo-ex--icon d-flex align-items-center" style="pointer-events: none">
                            <iconSymbol name="view" />
                            <span>{{ getNumberText(work.pv) }}</span>
                        </div>
                        <template v-if="!internal">
                            <div class="d-flex align-items-center">
                                <iconSymbol name="like" :class="{ 'mo-work--icon__blue': hasCollected }" @click.native="collect" />
                                <span>{{ getNumberText(work.collect) }}</span>
                            </div>
                            <div style="pointer-events: none" class="d-flex align-items-center">
                                <iconSymbol name="duplicate" />
                                <span>{{ getNumberText(work.used) }}</span>
                            </div>
                        </template>
                        <template v-else>
                            <div style="pointer-events: none">
                                <iconSymbol name="work-used" />
                                <span>{{ getNumberText(work.used) }}</span>
                            </div>
                            <div>
                                <iconSymbol name="work-like" :class="{ 'mo-work--icon__red': hasLiked }" @click.native="like()" />
                                <span>{{ getNumberText(work.like) }}</span>
                            </div>
                        </template>
                    </div>

                    <span v-if="internal && type == 'userWorks'" class="mo-work--use-condition">{{ priceHint }}</span>
                </div>
                <div v-if="type != 'userWorks'" class="mo-work--author-area" style="pointer-events: auto">
                    <div class="mo-work--author-info" @click="showUserWorks()">
                        <span
                            class="mo-work--author-name"
                            :style="{
                                color: work.fuser ? '#f98e5a' : null,
                                'max-width': internal ? '100px' : '',
                            }"
                        >
                            {{ safeName }}
                        </span>
                        <div v-if="!avatar" class="mo-work-default--avatar">
                            {{ getFirstName() }}
                        </div>
                        <img v-if="avatar" :src="avatar" class="mo-work--avatar" alt />
                    </div>
                    <span v-if="internal" class="mo-work--use-condition">{{ priceHint }}</span>
                </div>
            </div>
        </template>
    </div>
</template>
<i18n>
{
  "zh": {
    "hint": {
      "charge": "收费，",
      "free": "免费",
      "onlyPublic": "仅公开",
      "memberFree": "会员免费"
    },
    "bought": "已购买",
    "use": "立即使用",
    "useTip": "升级使用该模板",
    "cancelCollect": "取消收藏",
    "collect": "收藏"
  },
  "en": {
    "hint": {
      "charge": "Pay to use",
      "free": "Free to use",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "Paid",
    "use": "Use immediately",
    "useTip": "Upgrade to access this template.",
    "cancelCollect": "Remove from Favorites",
    "collect": "Favorites"
  },
  "de": {
    "hint": {
      "charge": "Pay to use",
      "free": "Free to use",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "Paid",
    "use": "Diese Vorlage verwenden",
    "useTip": "Führen Sie ein Upgrade durch, um auf diese Vorlage zuzugreifen.",
    "cancelCollect": "Von Favoriten entfernen",
    "collect": "Favoriten"
  },
  "fr": {
    "hint": {
      "charge": "Pay to use",
      "free": "Free to use",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "Paid",
    "use": "Utilisez ce modèle",
    "useTip": "Effectuez une mise à niveau pour accéder à ce modèle.",
    "cancelCollect": "Favori annulé",
    "collect": "Favoris"
  },
  "es": {
    "hint": {
      "charge": "Pagar para usar",
      "free": "Gratis de usar",
      "onlyPublic": "Solo ver",
      "memberFree": "Gratis para miembros"
    },
    "bought": "Pagados",
    "use": "Usa esta plantilla",
    "useTip": "Actualiza para acceder a esta plantilla.",
    "cancelCollect": "Eliminar de favoritos",
    "collect": "Favoritos"
  },
  "jp": {
    "hint": {
      "charge": "有料",
      "free": "無料",
      "onlyPublic": "View Only",
      "memberFree": "Free for members"
    },
    "bought": "購入済み",
    "use": "このテンプレートを使用する",
    "useTip": "このテンプレートを利用するには、アップグレードしてください。",
    "cancelCollect": "お気に入りをキャンセルしました",
    "collect": "お気に入り"
  },
  "pt": {
    "hint": {
      "charge": "Pague para usar",
      "free": "Livre para usar",
      "onlyPublic": "Exibir apenas",
      "memberFree": "Grátis para membros"
    },
    "bought": "Pago",
    "use": "Usar este modelo",
    "useTip": "Atualize para acessar este modelo.",
    "cancelCollect": "Remover dos Favoritos",
    "collect": "Coletar"
  },
  "it": {
    "hint": {
      "charge": "Paga per l'uso",
      "free": "Gratis",
      "onlyPublic": "Mostra solo",
      "memberFree": "VIP gratis"
    },
    "bought": "Pagato",
    "use": "Usa questo modello",
    "useTip": "Aggiorna per accedere a questo modello.",
    "cancelCollect": "Rimuovi dai Preferiti",
    "collect": "Preferiti"
  },
  "tw": {
    "hint": {
      "charge": "收費，",
      "free": "免費",
      "onlyPublic": "僅公開",
      "memberFree": "會員免費"
    },
    "bought": "已購買",
    "use": "使用此模板",
    "useTip": "Upgrade to access this template.",
    "cancelCollect": "取消收藏",
    "collect": "收藏"
  },
  "kr": {
    "hint": {
      "charge": "유료 사용",
      "free": "무료",
      "onlyPublic": "공개",
      "memberFree": "회원 무료"
    },
    "bought": "구매 완료",
    "use": "템플릿 적용하기",
    "useTip": "Upgrade to access this template.",
    "cancelCollect": "즐겨찾기 취소",
    "collect": "즐겨찾기"
  },
  "id": {
    "hint": {
      "charge": "Penggunaan berbayar",
      "free": "Penggunaan gratis",
      "onlyPublic": "Hanya Lihat",
      "memberFree": "Gratis untuk anggota"
    },
    "bought": "Berbayar",
    "use": "Gunakan segera",
    "cancelCollect": "Hapus dari Favorit",
    "collect": "Favorit"
  }
}
</i18n>
<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import "@/home/style/tplWaterfall-en.styl";
    @Component({})
    export default class TplWork extends Vue {
        @Prop({
            type: Object,
            required: true,
        })
        work;
        @Prop({
            type: String,
            required: true,
        })
        type;
        @Prop()
        index;

        //正在进行点赞操作
        doingLike: boolean = false;
        doingCollect: boolean = false;
        imgLoad = false;
        debug: boolean = window.location.host.indexOf("10") != -1;
        cloneFlag: boolean = false;

        get isHot() {
            return this.$store.state.workFilter.order == "HOT" && this.type == "center";
        }
        topColor(index) {
            return ["#DE3131", "#FF8A00", "#FFC700", "#89E82A", "#1FE1ED", "#00C999", "#00BDD7", "#0080DD", "#5D59FF", "#9000D3"][index];
        }
        get isParttime() {
            return this.$store.state.tplCenter.parttime;
        }
        get thumbSrc() {
            //如果是审核或者举报面板，会传一个带时间戳的thumbSrc过来,保证每次刷新之后都会从服务器请求最新的缩略图（因为缩略图可能会被修改，防止修改之后还显示的是浏览器缓存中的）
            let src = window["GLOBAL"].PUBLIC_OSS_HOST + this.work.url + "thumb.png";
            if (this.type == "review" || this.type == "report") src = this.work.thumbSrc;
            return src;
        }
        //头像
        get avatar() {
            let ava = "",
                work = this.work;
            if (work.avatar) ava = "data:image/png;base64," + work.avatar;
            else if (work.avatar_url) ava = work.avatar_url;
            else if (work.user && work.user.avatar) ava = "data:image/png;base64," + work.avatar;
            else if (work.user && work.user.avatar_url) ava = work.user.avatar_url;
            return ava;
        }
        //如果是author电话的话，将电话号码后6位隐藏
        //如果是邮箱的话，隐藏邮箱后缀
        get safeName() {
            let name = this.work.nick_name || this.work.author || (this.work.user && this.work.user.nick_name) || "";
            if (name.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
                name = name.substr(0, name.indexOf("@"));
            }
            if (name.match(/^1[3456789]\d{9}$/)) {
                name = name
                    .split("")
                    .map((v, idx) => {
                        if (idx > 4) {
                            return "*";
                        } else {
                            return v;
                        }
                    })
                    .join("");
            }
            return name;
        }
        getFirstName() {
            return this.work.nick_name ? this.work.nick_name.trim().split("")[0] : "";
        }
        get priceHint() {
            let work = this.work;
            let hint: any = "";
            if (["1", 1].includes(work.allow_copy)) {
                if (work.price > 0) {
                    hint = "￥" + work.price;
                } else if (["1", 1].includes(work.member_free)) {
                    hint = this.$t("hint.memberFree");
                } else {
                    hint = this.$t("hint.free");
                }
            } else {
                hint = this.$t("hint.onlyPublic");
            }
            return hint;
        }
        //是否点赞过
        get hasLiked() {
            let likeIds = this.$store.state.tplCenter.likeIds;
            return likeIds.includes(this.work.id - 0);
        }
        //是否点赞过
        get hasCollected() {
            let collectIds = this.$store.state.tplCenter.collectIds;
            return collectIds.includes(this.work.id - 0);
        }
        //是否购买过
        get hasBought() {
            let ids = [],
                boughtWorks = this.$store.state.tplCenter.boughtWorks || [];
            boughtWorks.forEach((item) => {
                ids.push(item.work_id);
            });

            return ids.includes(this.work.id - 0);
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get trackClass() {
            return this.$store.state.trackClass;
        }
        // --testOpenTemplate
        get testOpenTemplate() {
            return this.$store.state.testOpenTemplate;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get wrapStyle() {
            const width = this.work.cover_width || 340;
            const height = this.work.cover_height || 255;
            return {
                paddingBottom: `${(height / width) * 100}%`,
            };
        }
        loadErr(e) {
            e.target.classList.add("fail-img");
        }
        boughtWorks() {
            return this.$store.state.tplCenter.boughtWorks;
        }
        boughtWorkIds() {
            let ids = [];
            let bWorks = this.$store.state.tplCenter.boughtWorks || [];
            bWorks.forEach((item) => {
                ids.push(item.work_id);
            });
            return ids;
        }
        getNumberText(num) {
            if (Number(num) > 1000) {
                return (Number(num) / 1000).toFixed(1) + "k";
            } else {
                return num;
            }
        }
        showReviewModify() {
            this.$store.commit("toTplCenter", {
                name: "showReviewModify",
                data: true,
            });
            this.$store.commit("toActiveWork", this.work);
            if (this.isParttime) {
                this.preview();
            }
        }
        //显示预览界面
        preview() {
            if (!this.$validateLogin()) return;

            if (this.type == "searchPage") {
                this.$emit("openTemplate", "view");
            }

            let ts: any = this;
            let work = this.work;

            let diagramType = "notUseTemplate";
            if (this.$store.state.activeLv3) {
                diagramType = this.$store.state.activeLv3.lv3name;
            } else if (this.$store.state.activeLv2) {
                diagramType = this.$store.state.activeLv2.lv2name;
            } else if (this.$store.state.activeLv1) {
                diagramType = this.$store.state.activeLv1.lv1name;
            }
            this.$gaTrack("Template_clickCommunityTemplate", `diagramType: ${diagramType}`);
            this.sensors.track("clickCommunityTemplate", {
                Catalogues: "Templates",
                diagram_type: diagramType,
                platform: this.isPC ? "desktop" : "online",
            });

            // --testOpenTemplate
            if (this.testOpenTemplate && this.internal) {
                let flag = 0;
                if (work.user_id == this.userInfo.user_id) {
                    // 作品作者
                    flag = 1;
                }
                if (work.member_free && this.vipState) {
                    // 会员免费且用户是会员
                    flag = 1;
                }
                if (work.price > 0 && (this.boughtWorkIds() as any).includes(work.id - 0)) {
                    // 付费作品。用户已付费
                    flag = 1;
                }
                if (work.price <= 0 && work.member_free == 0) {
                    // 免费模板
                    flag = 1;
                }
                if (!(!this.work.member_free && this.work.price == 0)) {
                    if (!this.userInfo.islogin) {
                        flag = 0;
                    }
                }
                if (flag) {
                    this.pcClone();
                    return;
                }
            }

            // WsTrack('Community', "Preview");
            // ts.$track("Community", "Preview");
            //浏览量加一
            let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
            if (this.params && this.params.id) {
                this.$edApi
                    .viewOrReportWork(
                        Object.assign(
                            {
                                id: this.params.id,
                                workId: work.id - 0,
                                preview: 1,
                            },
                            this.params
                        )
                    )
                    .then(() => {
                        // this.$bus.$emit("updateWorkIds", { id: work.id, type: "pv" });
                        this.work.pv += 1;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            if (this.isPC) {
                // (<any>window).$qt.jsCallUploadData && (<any>window).$qt.jsCallUploadData(JSON.stringify({
                //     type: this.internal ? "S006_Use_Template_8" : "S018_Use_Template_EN",
                //     action: this.internal ? "SL040_Preview_Page" : "SL114_Preview_Page"
                // }));

                ts.$pcTrack(
                    JSON.stringify({
                        type: "openFileProcess",
                        action: "clickTemplate",
                        event: "experience",
                        label: JSON.stringify({
                            template_type: tType,
                        }),
                    })
                );
                ts.$pcTrack(
                    JSON.stringify({
                        type: "Templates",
                        action: "clickCommunityTemplate",
                        event: "experience",
                        label: JSON.stringify({
                            diagram_type: ts.trackClass,
                        }),
                    })
                );
            } else {
                this.sensors.track("previewCommunityTemplate", {
                    Catalogues: "openFileProcess",
                    template_type: tType,
                });
            }

            this.$store.commit("toActiveWork", work);
            this.$store.commit("toTplCenter", {
                name: "previewContext",
                data: this.type,
            });
        }
        toUse() {
            if (!this.$validateLogin()) return;
            if (this.type == "searchPage") {
                this.sensors.track("searchResultClickTemplatePopup", {
                    Catalogues: "searchMainpage",
                    action: "click",
                    value: "use",
                });
            }
            this.$store.commit("toActiveWork", this.work);
            this.$bus.$emit("doClone");
        }
        pcClone() {
            if (this.cloneFlag) return;
            this.cloneFlag = true;
            let { id: workId, path, sign, exp, title: fileName, member_free } = this.work;
            let win: any = window;
            //通知pc端clone
            let callPcAction = (sign, exp, path, checkmfree) => {
                if (this.internal) {
                    sign = encodeURIComponent(sign);
                }
                let param = {
                    id: workId,
                    fileName,
                    sign,
                    exp,
                    obj: path,
                    type: "clone",
                    track: workId + "",
                    accessid: this.OSSAccessKeyId,
                };
                if (checkmfree) {
                    param["checkmfree"] = 1;
                }
                this.cloneFlag = false;
                win.$qt.jsCallCloudFileOperate(JSON.stringify(param));
            };

            //如果是会员免费，先调接口获取作品源文件下载信息
            if (member_free || this.work.user_id == this.userInfo.user_id) {
                this.$edApi
                    .getWorkDownInfo({
                        id: this.params.id,
                        workId,
                        token: this.params.token,
                    })
                    .then((data) => {
                        sign = data.sign;
                        exp = data.exp;
                        path = data.path;
                        callPcAction(sign, exp, path, true);
                    })
                    .catch((error) => {
                        this.cloneFlag = false;
                    });
            } else {
                //如果是已购买的，从购买信息中获取sign和exp。如果是免费的就用preItem中的sign和exp
                if (this.work.price > 0) {
                    let boughtInfo = (this.boughtWorks() as any).find((boughtWork) => {
                        if (boughtWork.work_id == workId) return boughtWork;
                    });

                    sign = boughtInfo.sign;
                    exp = boughtInfo.exp;
                    path = boughtInfo.path;
                }
                callPcAction(sign, exp, path, false);
            }
            // this.closePre();
        }
        //点赞或取消赞
        like() {
            let ts: any = this;
            // WsTrack("Community", "Like");
            // ts.$track("Community", "Like");
            let userInfo = this.$store.state.userInfo;
            if (!userInfo && this.$store.state.user) {
                userInfo = this.$store.state.user.userInfo;
            }
            if (this.isPC && userInfo && !userInfo.islogin) {
                (<any>window).$qt.jsCallUpdateLoginTrigger && (<any>window).$qt.jsCallUpdateLoginTrigger("likesTemplates");
            }
            if (!this.$validateLogin()) return;
            if (this.doingLike) return;
            let workId = this.work.id - 0;
            this.doingLike = true;
            if (this.hasLiked) {
                //取消点赞
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId,
                        like: 0,
                    })
                    .then(() => {
                        this.$bus.$emit("updateWorkIds", { id: workId, type: "dislike" });
                        this.$bus.$emit("updateWorkIds2", { id: workId, type: "dislike" });
                        this.doingLike = false;
                    });
            } else {
                //点赞
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId,
                        like: 1,
                    })
                    .then(() => {
                        this.sensors.track("likeTemplate", {
                            Catalogues: "publish template",
                        });
                        this.$bus.$emit("updateWorkIds", { id: workId, type: "like" });
                        this.$bus.$emit("updateWorkIds2", { id: workId, type: "like" });
                        this.doingLike = false;
                        if (this.isPC) {
                            this.$pcTrack(
                                JSON.stringify({
                                    type: "publish template",
                                    action: "likeTemplate",
                                    event: "experience",
                                })
                            );
                        }
                    });
            }
        }
        collect() {
            let userInfo = this.$store.state.userInfo;
            if (!userInfo && this.$store.state.user) {
                userInfo = this.$store.state.user.userInfo;
            }
            if (this.isPC && userInfo && !userInfo.islogin) {
                (<any>window).$qt.jsCallUpdateLoginTrigger && (<any>window).$qt.jsCallUpdateLoginTrigger("favoritesTemplates");
            }
            if (!this.$validateLogin()) return;
            if (this.doingCollect) return;

            if (this.type == "searchPage") {
                this.$emit("trackTemplate", "favorite");
            }

            this.doingCollect = true;
            let id = this.work.id - 0;
            if (this.hasCollected) {
                // 取消收藏
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId: id,
                        collect: 0,
                    })
                    .then(() => {
                        this.$bus.$emit("updateWorkIds", { id, type: "discollect" });
                        this.$bus.$emit("updateWorkIds2", { id, type: "discollect" });
                        this.doingCollect = false;
                    });
            } else {
                // 收藏
                this.$edApi
                    .likeOrCollectWork({
                        id: this.params.id,
                        token: this.params.token,
                        workId: id,
                        collect: 1,
                    })
                    .then(() => {
                        // 首次操作时弹窗提示
                        if (!localStorage.getItem("checkCollect")) {
                            localStorage.setItem("checkCollect", "true");
                            this.$store.commit("setState", {
                                type: "collectModal",
                                data: true,
                            });
                        }
                        this.$bus.$emit("updateWorkIds", { id, type: "collect" });
                        this.$bus.$emit("updateWorkIds2", { id, type: "collect" });
                        this.doingCollect = false;
                    });
            }
        }

        showUserWorks() {
            if (!this.$validateLogin()) return;
            let ts: any = this;
            // WsTrack("Community", "WorkCenter", "Show");
            // ts.$track("Community", "WorkCenter", "Show");
            let id = this.work.user_id,
                fuser = this.work.fuser;
            if (this.isPC && this.internal) {
                this.$store.commit("toTplCenter", {
                    name: "showUserWorks",
                    data: true,
                });

                this.$store.commit("toVisitUser", {
                    id,
                    fuser: fuser ? true : false,
                });
            } else {
                let path = this.internal ? "templates/user" : "templates/users";
                let href = `${window.location.origin}/${path}/${id}`;
                if (this.isPC) {
                    (<any>window).$qt.jsCallOpenUrl(href);
                } else {
                    window.open(href);
                }
            }
        }
        deleteWorkFromAlbum() {
            this.$bus.$emit("deleteWorkFromAlbum", this.work.id);
        }
        addWorkToAlbum() {
            this.$bus.$emit("addWorkToAlbum", this.work.id);
        }
    }
</script>
<style lang="stylus">
    .mo-work
        .mo-work--operation
            right: 86px;
            top: 20px;
        .mo-work--thumb-error
            position: absolute;
            left: 20px;
            top: 20px;
</style>
